import React from "react";
import HomeContainer from "../../containers/HomeContainer/HomeContainer";

const HomePage = () => {
  return <HomeContainer />;
};

export default HomePage;
